//# sourceMappingURL=iso639.mjs.map
/// <reference types="./iso639.d.mts" />
import * as $json from "../../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $language from "../../../data/translate/language.mjs";
import { Ok, Error } from "../../../gleam.mjs";

export function to_string(language) {
  if (language instanceof $language.English) {
    return "en";
  } else if (language instanceof $language.French) {
    return "fr";
  } else if (language instanceof $language.German) {
    return "de";
  } else if (language instanceof $language.Spanish) {
    return "es";
  } else if (language instanceof $language.Dutch) {
    return "nl";
  } else if (language instanceof $language.Portuguese) {
    return "pt";
  } else if (language instanceof $language.Italian) {
    return "it";
  } else if (language instanceof $language.Finnish) {
    return "fi";
  } else if (language instanceof $language.Swedish) {
    return "sv";
  } else if (language instanceof $language.Nynorsk) {
    return "nn";
  } else if (language instanceof $language.Bokmal) {
    return "nb";
  } else if (language instanceof $language.Danish) {
    return "da";
  } else if (language instanceof $language.Estonian) {
    return "et";
  } else if (language instanceof $language.Latvian) {
    return "lv";
  } else if (language instanceof $language.Lithuanian) {
    return "lt";
  } else if (language instanceof $language.Icelandic) {
    return "is";
  } else if (language instanceof $language.Japanese) {
    return "ja";
  } else if (language instanceof $language.Chinese) {
    return "zh";
  } else if (language instanceof $language.Polish) {
    return "pl";
  } else if (language instanceof $language.Romanian) {
    return "ro";
  } else if (language instanceof $language.Bulgarian) {
    return "bg";
  } else if (language instanceof $language.Croatian) {
    return "hr";
  } else if (language instanceof $language.Czech) {
    return "cs";
  } else if (language instanceof $language.Greek) {
    return "el";
  } else if (language instanceof $language.Hungarian) {
    return "hu";
  } else if (language instanceof $language.Irish) {
    return "ga";
  } else if (language instanceof $language.Slovak) {
    return "sk";
  } else if (language instanceof $language.Slovene) {
    return "sl";
  } else if (language instanceof $language.Arabic) {
    return "ar";
  } else if (language instanceof $language.Korean) {
    return "ko";
  } else if (language instanceof $language.Russian) {
    return "ru";
  } else if (language instanceof $language.Turkish) {
    return "tr";
  } else if (language instanceof $language.Hindi) {
    return "hi";
  } else if (language instanceof $language.Hebrew) {
    return "he";
  } else if (language instanceof $language.Vietnamese) {
    return "vi";
  } else if (language instanceof $language.Indonesian) {
    return "id";
  } else if (language instanceof $language.Thai) {
    return "th";
  } else if (language instanceof $language.Ukrainian) {
    return "uk";
  } else {
    return "ms";
  }
}

export function parse(digram) {
  if (digram === "fr") {
    return new Ok(new $language.French());
  } else if (digram === "en") {
    return new Ok(new $language.English());
  } else if (digram === "es") {
    return new Ok(new $language.Spanish());
  } else if (digram === "de") {
    return new Ok(new $language.German());
  } else if (digram === "nl") {
    return new Ok(new $language.Dutch());
  } else if (digram === "pt") {
    return new Ok(new $language.Portuguese());
  } else if (digram === "it") {
    return new Ok(new $language.Italian());
  } else if (digram === "fi") {
    return new Ok(new $language.Finnish());
  } else if (digram === "sv") {
    return new Ok(new $language.Swedish());
  } else if (digram === "nn") {
    return new Ok(new $language.Nynorsk());
  } else if (digram === "nb") {
    return new Ok(new $language.Bokmal());
  } else if (digram === "da") {
    return new Ok(new $language.Danish());
  } else if (digram === "et") {
    return new Ok(new $language.Estonian());
  } else if (digram === "lv") {
    return new Ok(new $language.Latvian());
  } else if (digram === "lt") {
    return new Ok(new $language.Lithuanian());
  } else if (digram === "is") {
    return new Ok(new $language.Icelandic());
  } else if (digram === "ja") {
    return new Ok(new $language.Japanese());
  } else if (digram === "zh") {
    return new Ok(new $language.Chinese());
  } else if (digram === "pl") {
    return new Ok(new $language.Polish());
  } else if (digram === "ro") {
    return new Ok(new $language.Romanian());
  } else if (digram === "bg") {
    return new Ok(new $language.Bulgarian());
  } else if (digram === "hr") {
    return new Ok(new $language.Croatian());
  } else if (digram === "cs") {
    return new Ok(new $language.Czech());
  } else if (digram === "el") {
    return new Ok(new $language.Greek());
  } else if (digram === "hu") {
    return new Ok(new $language.Hungarian());
  } else if (digram === "ga") {
    return new Ok(new $language.Irish());
  } else if (digram === "sk") {
    return new Ok(new $language.Slovak());
  } else if (digram === "sl") {
    return new Ok(new $language.Slovene());
  } else if (digram === "ar") {
    return new Ok(new $language.Arabic());
  } else if (digram === "ko") {
    return new Ok(new $language.Korean());
  } else if (digram === "ru") {
    return new Ok(new $language.Russian());
  } else if (digram === "tr") {
    return new Ok(new $language.Turkish());
  } else if (digram === "hi") {
    return new Ok(new $language.Hindi());
  } else if (digram === "he") {
    return new Ok(new $language.Hebrew());
  } else if (digram === "vi") {
    return new Ok(new $language.Vietnamese());
  } else if (digram === "id") {
    return new Ok(new $language.Indonesian());
  } else if (digram === "th") {
    return new Ok(new $language.Thai());
  } else if (digram === "uk") {
    return new Ok(new $language.Ukrainian());
  } else if (digram === "ms") {
    return new Ok(new $language.Malay());
  } else {
    return new Error(undefined);
  }
}

export function decoder() {
  return $decode.then$(
    $decode.string,
    (language) => {
      let $ = parse(language);
      if ($ instanceof Ok) {
        let language$1 = $[0];
        return $decode.success(language$1);
      } else {
        return $decode.failure(new $language.English(), "Language");
      }
    },
  );
}

export function encode(language) {
  let language$1 = to_string(language);
  return $json.string(language$1);
}

export function resolve(language) {
  let _pipe = parse(language);
  let _pipe$1 = $result.lazy_or(
    _pipe,
    () => { return $language.from_string(language); },
  );
  return $result.unwrap(_pipe$1, new $language.English());
}
